import script from "./ArtisanList.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtisanList.vue?vue&type=script&setup=true&lang=js"

import "./ArtisanList.vue?vue&type=style&index=0&id=72ac1586&scoped=true&lang=css"
import "./ArtisanList.vue?vue&type=style&index=1&id=72ac1586&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ac1586"]])

export default __exports__